import React from 'react';
import { createRoot } from 'react-dom/client';
import { promisifyModal } from 'common/components/modal/utils';
import { Metadata, ModalTrigger } from './util';
import { InProductUpsellModalRct } from './index';

/**
 * Utility to inject the modal into the DOM and resolve a promise when the modal is closed.
 * Unfortunately, the underlying close functions are quite slow, but reduces template overhead.
 * More useful in Panel than in React, since state management is much simpler in React.
 * For some reason, this breaks Vite when in index, so it's in a separate file.
 *
 * @param modalTrigger - The trigger for the modal.
 */
export async function promptInProductUpsellModal(modalTrigger: ModalTrigger, metadata?: Metadata): Promise<boolean> {
  const props = {
    modalTrigger,
    open: true,
    metadata
  };
  return promisifyModal({
    attrs: {},
    closeEvents: [],
    onElementCreatedCallback: (element, onCloseCallback) => {
      const reactRoot = createRoot(element);
      reactRoot.render(<InProductUpsellModalRct {...props} closeModal={() => onCloseCallback()} />);
    },
    props,
    shouldDelayClose: false
  });
}